import { render, staticRenderFns } from "./CoursewareCodeBlock.vue?vue&type=template&id=acd5e34c&"
import script from "./CoursewareCodeBlock.vue?vue&type=script&lang=js&"
export * from "./CoursewareCodeBlock.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareCodeBlock.vue?vue&type=style&index=0&id=acd5e34c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports